import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPaginationState {
  data: any;
  filters: Record<string, string | number>;
  searchQuery: string;
}

const initialState: IPaginationState = {
  data: { segments: {}, summary: {} },
  filters: {
    period: "last_30_days",
  },
  searchQuery: "",
};

const PaginationSlice = createSlice({
  name: "CustomerRetentionAndChurnPagination",
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<{ data: any }>) => {
      const { data } = action.payload;
      state.data = data;
    },
    setFilters: (
      state,
      action: PayloadAction<Record<string, string | number>>,
    ) => {
      state.filters = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
  },
});

export const { setData, setFilters, setSearchQuery } = PaginationSlice.actions;

export const selectPagination = (state: {
  CustomerRetentionAndChurnPagination: IPaginationState;
}) => state.CustomerRetentionAndChurnPagination;

export default PaginationSlice.reducer;
